<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import ShowPasswordModal from '@/components/showPasswordModal.vue';
import { toast, variants } from "@/helpers/toaster";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: 'Novi objekat',
  },
  components: {ErrorAlert, Layout, ShowPasswordModal},
  methods: {
    async submitForm() {
      const req = {
        partner_id: this.partner.partner_id,
        partner_name: this.partner.partner_name,
        object_id: this.object_id,
        object_code: this.object_code,
        object_name: this.object_name,
        object_number: this.object_number,
        object_address: this.object_address,
        object_address2: this.object_address2,
        contact: this.contact,
        name: this.name,
        email: this.email,
      };

      if (this.limit) req['limit'] = this.limit;
      this.$store.commit('loader/START_LOADING');

      try {
        const response = await axios.post(`/super-admin/employees/`, req);
        toast('Uspešno kreiranje objekta.', variants.SUCCESS)

        this.password = response.data.plain_password;
        this.showModal = true;
      } catch(e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },

    cancel() {
      this.$router.push(`/super-admin/employees`)
    },
    close() {
      this.showModal = false;
      this.cancel();
    }
  },
  async created() {
    this.$store.commit('loader/START_LOADING');
    
    await axios.get('/super-admin/employees/distinct-partners').then((r) => {
      this.partners = r.data
    }).finally(() => this.$store.commit('loader/END_LOADING'));
  },
  data() {
    return {
      showModal: false,
      password: '',
      partner_name: '',
      partner_id: '',
      object_id: '',
      object_code: '',
      object_name: '',
      object_number: '',
      object_address: '',
      object_address2: '',
      contact: '',
      limit: '',
      name: '',
      email: '',
      partners: [],
      partner: null,
    };
  },
};
</script>

<template>
  <Layout>
    <show-password-modal title="Uspešno kreiranje objekta" :password="password" :showModal="showModal" @closed="close"/>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">

        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Partner
              </label>
              <select v-model="partner" @click.stop class="form-control custom-select px-2">
                <option :value="null" disabled selected>Izaberi partnera...</option>
                <option v-for="p in partners" :key="p.partner_id" :value="p">
                  {{ p.partner_name ? p.partner_name : 'Partner: ' + p.partner_id }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>
                Naziv partnera
              </label>
              <b-form-input v-model="partner_name"  id="employee-partner-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Id objekta
              </label>
              <b-form-input v-model="object_id" placeholder="" 
                            id="employee-object-id-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Naziv objekta
              </label>
              <b-form-input v-model="object_name" placeholder="" 
                            id="employee-object-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Šifra objekta
              </label>
              <b-form-input v-model="object_code" placeholder="" 
                            id="employee-object-code-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Adresa objekta
              </label>
              <b-form-input v-model="object_address" placeholder="" 
                            id="employee-object-address-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Adresa objekta 2
              </label>
              <b-form-input v-model="object_address2" placeholder="" 
                            id="employee-object-address-2-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Broj objekta
              </label>
              <b-form-input v-model="object_number" placeholder="" 
                            id="employee-object-number-input" type="number"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Kontakt
              </label>
              <b-form-input v-model="contact" placeholder="" 
                            id="employee-contact-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Limit
              </label>
              <b-form-input v-model="limit" placeholder="" 
                            id="employee-limit-input" type="number"></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Ime objekta
              </label>
              <b-form-input v-model="name" placeholder="" 
                            id="employee-name-input" type="text"></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Email
              </label>
              <b-form-input v-model="email" placeholder="" 
                            id="employee-name-input" type="text"></b-form-input>
            </div>
              <div class="text-right">
                <b-button type="button" variant="secondary" @click="cancel()">Otkaži</b-button>
                <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
              </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>

input[type='radio'] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease .3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #FF5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #FFC107;
}

.lime .button span {
  background: #8BC34A;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196F3;
}

.indigo .button span {
  background: #3F51B5;
}

</style>
